import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../config.json";
import Table from "../Common/table";
import dateTime from "../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../utill/Excelimport";
import Loading from "../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";
import { Content } from "antd/es/layout/layout";
import PaginationComponent from "../Common/PaginationComponent";

const RMInventory = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "RM_ID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [VendorList, setVendorList] = useState([]);

  const [RMStorageList, setRMStorageList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [RMlist, setRMlist] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);
  const [RMIdList, setRMIdList] = useState([]);
  const [UnitOfMeasurment, setUnitOfMeasurment] = useState("");

  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");

  const [BatchCode, setBatchCode] = useState("");

  const [Remarks, setRemarks] = useState("");
  const [RawMaterialData, setRawMaterialData] = useState([]);

  const [ChekpointId, setChekpointId] = useState("");
  const [formData, setFormData] = useState({});
  const [Date, setDate] = useState([]);
  const [spareList, setspareList] = useState([]);
  const { Panel } = Collapse;
   const [CurrentPage, setCurrentPage] = useState(1);
      const [TotalPage, setTotalPage] = useState(0);
      const [PageSize, setPageSize] = useState(50);
  
  function callback(key) {
    console.log(key);
  }
  console.log(PdfData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...RawMaterialData];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setRawMaterialData(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'Enable' values
    const updatedList = RawMaterialData.map((one) => ({
      ...one,
      Enable: isChecked,
    }));

    // Update state
    setRawMaterialData(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };

  const columns = [
    {
      key: "select",
      label: <input type="checkbox" onChange={handelSelectAll}   checked={(RawMaterialData.filter(one=> (one.Enable ==false ||  one.Enable ==undefined))).length > 0 ?false :true} />,

      content: (obj) => (
        <input
          type="checkbox"
          checked={obj["Enable"]}
          onChange={(e) => handelOnPDfEnable(e, obj)}
        />
      ),
    },
    { path: "RM_Type", label: "RM Type" },
    { path: "RM_ID", label: "RM ID" },
    { path: "Vendor", label: "Vendor" },
    {
      path: "InvoiceDate",
      label: "Invoice Date",
      content: (obj) => (
        <label>{moment(obj.InvoiceDate).format("DD-MM-YY")}</label>
      ),
    },
    { path: "InvoiceNo", label: "Invoice No" },
    { path: "ReceivedQty", label: "Received Qty" },
    { path: "NumOfPackings", label: "Number Of Packings" },

    
    { path: "Location", label: "Location" },
    { path: "TestReportNo", label: "Test Report No" },
    // {
    //   path: "ConsumedQty",
    //   label: "Consumed Qty",
    //   content: (obj) => (
    //     <Collapse defaultActiveKey={['1']} >
    // <Panel header="Consumed Qty" key="1">
    //       <table>
    //         <tbody style={{ padding: 0, backgroundColor: "white" }}>
    //           {obj.ConsumedQty &&
    //             obj.ConsumedQty.map((item) => (
    //               <tr className="text-center" key={item._id}>
    //                 <td style={{ padding: 1, textAlign: "center" }}>
    //                   {moment(item.Date).format("DD-MM-YYYY")}
    //                 </td>
    //                 <td style={{ padding: 1, textAlign: "center" }}>{item.Qty}</td>
    //                 <td style={{ padding: 1, textAlign: "center" }}>
    //                   {item.ReferenceObj}
    //                 </td>
    //               </tr>
    //             ))}
    //         </tbody>
    //       </table>
    //       </Panel>
    //       </Collapse>
    //   ),
    // },
    // {
    //   path: "AdjustedQty",
    //   label: "Adjusted Qty",
    //   content: (obj) => (
    //     <div>
    //       <table>
    //         <tbody style={{ padding: 0, backgroundColor: "white" }}>
    //           {obj.Adjusted_Qty &&
    //             obj.Adjusted_Qty.map((item) => (
    //               <tr className="text-center" key={item._id}>
    //                 <td style={{ padding: 1, textAlign: "center" }}>
    //                   {moment(item.Date).format("DD-MM-YYYY")}
    //                 </td>
    //                 <td style={{ padding: 1, textAlign: "center" }}>{item.Qty}</td>
    //                 <td style={{ padding: 1, textAlign: "center" }}>{item.Type}</td>
    //                 <td style={{ padding: 1, textAlign: "center" }}>
    //                   {item.Remarks}
    //                 </td>
    //               </tr>
    //             ))}
    //         </tbody>
    //       </table>
    //     </div>
    //   ),
    // },
    { path: "Available_Qty", label: "Available Qty" },
    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
        </React.Fragment>
      ),
    },
    {
      key: "view",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("DynamicDataRights", RightName, "read")
          }
          onClick={() => {
            console.log(user, "View clicked");
            setUpdate(user);
            setopStatus("view");
            const UnitOfMeasurement = _.find(RMlist, {
              RM_ID: user.RM_ID,
            });
           
            if (UnitOfMeasurement) {
            }
            if (UnitOfMeasurement?.UnitOfMeasurement) {
              setUnitOfMeasurment(UnitOfMeasurement.UnitOfMeasurement);
            } else {
              console.warn(
                "UnitOfMeasurement is not available in filteredMeasurmentUnit."
              );
            }
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
    {
      key: "update",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("DynamicDataRights", RightName, "update")
          }
          onClick={() => {
            console.log(user, "Edit clicked");
            setUpdate(user);
            setopStatus("update");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
     {
          key: "delete",
          content: (user) => (
            <button
              disabled={
                !getRightsForAccess("DynamicDataRights", RightName, "update")
              }
              onClick={() => onDelete(user)}
              className="btn btn-sm btn-danger"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          ),
        },
  ];

  useEffect(() => {
    if (opStatus == "view" || opStatus == "update") {
      // setRows(Update.checkpoints);
      setQRCodeVisible(true);
      console.log(Update,"fhjbhb")
      setInputData(Update);
      setmodelState(true);
      if(Update && Update.RM_Type){
        handleOnChange({currentTarget: { name: "RM_Type", value: Update.RM_Type }})

      }
    } else {
      setRows([]);
    }
  }, [opStatus]);

  useEffect(() => {
    Heading("Add RM Inventory");
    getRMTypeMaster();
    getVendorMaster();
    getRMStorageMaster();
    getComponentCodeData();
    // RawMatreialMaster();
  }, []);
  const getVendorMaster = () => {
    axios
      .get(api.api + "vendor")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.Vendor,
          value: one.Vendor,
        }));
        setVendorList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
    useEffect(() => {
      RawMatreialMaster()
    }, [CurrentPage, PageSize]);

  const getRMStorageMaster = () => {
    axios
      .get(api.api + "rmStorageWater")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.StorageLocation,
          value: one.StorageLocation,
        }));
        setRMStorageList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMTypeMaster = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        const data = _.uniqBy(result.data, "RM_Type");
        const list = data.map((one) => ({
          Name: one.RM_Type,
          value: one.RM_Type,
        }));
        setTemplateList(list);
        setRMlist(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getComponentCodeData = () => {
    // axios
    //   .get(api.api + "RM_Type")
    //   .then((result) => {
    //     setRawMaterialData(result.data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
  const RawMatreialMaster = () => {
    axios
      .put(api.api + "RMDataEntry", { query: '', PageSize, Page: CurrentPage })
      .then((result) => {
        if (result?.data?.data) {
          // Sort the data based on 'updatedAt'
          const sortedData = [...result.data.data].sort((a, b) =>
            b.updatedAt.localeCompare(a.updatedAt)
          );
  
          // Update the state with sorted data
          setRawMaterialData(sortedData);
          setTotalPage(result.data.totalDocuments);
        } else {
          console.error("Unexpected response structure:", result);
        }
      })
      .catch((err) => {
        console.error("Error fetching raw material data:", err);
      });
  };
  

  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "currect dowload function dta");
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `RmInventory.pdf`
    );

    if (opStatus !== "view") {
      handleCloseModel();
    }
  };

  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(Inputdata.NumOfPackings);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }

    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = `CC : ${Inputdata.RM_Type};BN : ${
      Inputdata.InvoiceNo
    };TC : ${Inputdata.TestReportNo};MD : ${moment(
      Inputdata.InvoiceDate
    ).format("DD-MM-YY")};ED : ${moment(Inputdata.ExpiryDate).format(
      "DD-MM-YY"
    )};QT : ${Inputdata.Qty}`;

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter:'always' }}
            >
              <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: `repeat(${Math.sqrt(
                                16
                              )}, 1fr)`, // 3 columns in each row
                              gridTemplateRows: `repeat(${Math.sqrt(
                                16
                              )}, auto)`, // 3 rows per page (auto height)
                              gap: "57px", // Optional: Adjust the gap between items as needed
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                          >
                            {group.map((one, index) => (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center "
                                key={index}
                                style={{ textAlign: "center",marginBottom:'10px'}}
                              >
                                <QRCodeSVG
                                  value={one.QrCode}
                                  level={'M'}
                                  size={80}
                                  style={{marginBottom:'3px'}}
                                />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.RM_Type}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.InvoiceNo}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >{`${index + 1} / ${Inputdata.NumOfPackings}`}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (RawMaterialData.length > 0) {
      const sorted = _.orderBy(
        RawMaterialData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
console.log(sorted,"sorted data from table");
      setRawMaterialData(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    InvoiceNo: joi.string().required(),
    RM_Type: joi.string().required(),
    TestReportNo: joi.string().required(),
    InvoiceDate: joi.string().required(),
    ExpiryDate: joi.string().required(),
    Qty: joi.number().required(),
    NumOfPackings: joi.number().required(),
    _id: joi.string(),
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;
    if (name === "RM_Type") {
      const filteredArray = _.filter(RMlist, { RM_Type: value });
      console.log(RMlist,"RMlist testing data",filteredArray)
      if (filteredArray.length > 0) {
        const list = filteredArray.map((one) => ({
          Name: one.RM_ID,
          value: one.RM_ID,
        }));

        if(opStatus !== "update"){
          setInputData((prev) => ({
            ...prev,
            ["RM_ID"]: "",
          }));
        }
      

      
        setRMIdList(list);
      } else {
        console.warn("No RMs found for the selected RM_Type.");
        setRMIdList([]);
      }
      
      setInputData((prev) => ({
        ...prev,
        [name]: value[0],
      }));
    }
    if(name =="RM_ID"){
      const UnitOfMeasurement = _.find(RMlist, {
        RM_ID: value,
      });
    
      if (UnitOfMeasurement) {
      }
      if (UnitOfMeasurement?.UnitOfMeasurement) {
        setUnitOfMeasurment(UnitOfMeasurement.UnitOfMeasurement);
      } else {
        console.warn(
          "UnitOfMeasurement is not available in filteredMeasurmentUnit."
        );
      }
    }
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "RMDataEntry/" + data._id, { data: data })
          .then((result) => {
            RawMatreialMaster();
            toast.success(`Deleted  Successfully`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data, AdjustedQty) => {
    console.log(data, "cvosjnvjnv", AdjustedQty);
    const checksheet = { ...AdjustedQty[0] };

    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    checksheet["UniqueID"] = data.UniqueID;
    setLoader(true);
    if (opStatus == "update") {
      if(AdjustedQty && AdjustedQty.length > 0){

        axios
        .post(api.api + "adjustInventory", checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getComponentCodeData();
          // setQRCodeVisible(true);
          RawMatreialMaster();
          handleCloseModel();
          setAdjustedQty([]);
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
      setLoader(false);

          }
          console.log(err);
          setLoader(false);
        });
        
      }
        axios
        .patch(api.api + "RMDataEntry", Inputdata)
        .then((result) => {
          swal("Data Update Successfully");
          handleCloseModel();
          // }
          RawMatreialMaster();
          getComponentCodeData();

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          setLoader(false);

          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "RMDataEntry", Inputdata)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(Inputdata.NumOfPackings);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          if (qrCodeGroups.length > 0) {
            downloadPDF(qrCodeGroups, Inputdata);
          }
          // if(Result){
          handleCloseModel();
          // }
          RawMatreialMaster();
          getComponentCodeData();

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          setLoader(false);

          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];
    data.map(
      (one) =>
        one.Enable &&
        [...Array(Math.min(one.NumOfPackings))].forEach((_, j) => {
          pdf.push({
            QrCode: JSON.stringify({
                RMID: one.RM_ID,
                VD: one.Vendor,
                INo: one.InvoiceNo,
                IDt: moment(one.InvoiceDate).format("DD-MM-YY"),
                RQty: one.ReceivedQty,
                UID: one.UniqueID,
                SL: one.Location,
            }),
            index: j,
            RM_ID: one.RM_ID,
            UID: one.UniqueID,

            InvoiceDate: moment(one.InvoiceDate).format("DD-MM-YY"),
            Location: one.Location,
            NumOfPackings: one.NumOfPackings,
          });
        })
    );
    const qrCodeGroups = [];
    // const stickersPerPage = 20; // 4x5 grid on each page
    const stickersPerPage = 20; // 4x5 grid on each page
    const totalStickers = Number(pdf.length);
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };

  const handelONaddSpare = (Date, Type, Quantity, Remarks) => {
    if (Date && Type && Quantity) {
      setAdjustedQty((prev) => [
        ...prev,
        { Date: Date, Type: Type, Qty: Quantity, Remarks: Remarks },
      ]);
    } else {
      swal("Please Fill Required Fields");
    }
    setDate("");
    setQuantity("");

    setType("");
    setRemarks("");
  };
  const handleClear = (data1, index) => {
    const data = [...AdjustedQty];
    if (index > -1) {
      // only splice array when item is found
      data.splice(index, 1); // 2nd parameter means remove one item only
    }
    setAdjustedQty(data);
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {/* <FontAwesomeIcon icon={faCircle} style={{color: "#0bd408",}} /> */}
            {opStatus == "create"
              ? "Add"
              : opStatus == "update"
              ? "Update"
              : "View"}{" "}
           RM Inventory{" "}
            {opStatus == "create" ? (
              ""
            ) : (
              <div className="bg-success rounded">
                Available Qty : {Inputdata.Available_Qty}
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}
          <Row>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex ">
                <div className="w-25" htmlFor="operationRejectionCost">
                  RM Type
                </div>
                <div className="w-75">
                  <AntdSelect
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    placeholder="Select RM Type."
                    onChange={(value) => {
                      const template = templateList.find(
                        (x) => x.Name == value
                      );
                      setSelectedTemplate(template || {});
                      handleOnChange({
                        currentTarget: { name: "RM_Type", value: value },
                      });
                    }}
                    value={Inputdata.RM_Type || []}
                    style={{ width: "100%" }}
                  >
                    {templateList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Test Report Number"
                    disabled={false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="TestReportNo"
                    value={Inputdata.RM_Type}
                  /> */}
                </div>

                {errors.RM_Type && (
                  <div className="alert small alert-danger">
                    {errors["RM_Type"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  RM ID
                </div>
                <div className="w-75">
                  <AntdSelect
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    placeholder="Select RM ID."
                    onChange={(value) => {
                      const template = templateList.find(
                        (x) => x.Name == value
                      );
                      setSelectedTemplate(template || {});
                      handleOnChange({
                        currentTarget: { name: "RM_ID", value: value },
                      });
                    }}
                    value={Inputdata.RM_ID || []}
                    style={{ width: "100%" }}
                  >
                    {RMIdList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="RM Id"
                    disabled={false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="RM_ID"
                    value={Inputdata.RM_ID}
                  /> */}
                </div>

                {errors.RM_ID && (
                  <div className="alert small alert-danger">
                    {errors["RM_ID"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Vendor
                </div>
                <div className="w-75">
                  <AntdSelect
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    placeholder="Select Vendor."
                    onChange={(value) => {
                      const template = templateList.find(
                        (x) => x.Name == value
                      );
                      setSelectedTemplate(template || {});
                      handleOnChange({
                        currentTarget: { name: "Vendor", value: value },
                      });
                    }}
                    value={Inputdata.Vendor || []}
                    style={{ width: "100%" }}
                  >
                    {VendorList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="RM Id"
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Vendor"
                    value={Inputdata.Vendor}
                  /> */}
                </div>

                {errors.Vendor && (
                  <div className="alert small alert-danger">
                    {errors["Vendor"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Invoice Date
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    placeholder="Invoice Date"
                    className="form-control form-control-sm"
                    type="date"
                    name="InvoiceDate"
                    value={
                      (Inputdata.InvoiceDate &&
                        Inputdata.InvoiceDate.split("T")[0]) ||
                      ""
                    }
                  />
                </div>

                {errors.InvoiceDate && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceDate"]}
                  </div>
                )}
              </div>
            </Col>{" "}
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Invoice No
                </div>
                <div className="w-75">
                  <input
                    required
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    placeholder="Invoice No"
                    name="InvoiceNo"
                    value={Inputdata.InvoiceNo}
                  />
                </div>

                {errors.InvoiceNo && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceNo"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Recieved Qty{" "}
                  {UnitOfMeasurment.length > 0 && "(" + UnitOfMeasurment + ")"}
                </div>
                <div className="w-75">
                  <input
                    required
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control form-control-sm"
                    type="number"
                    // min="0"
                    placeholder="Recieved Qty"
                    name="ReceivedQty"
                    value={Inputdata.ReceivedQty}
                  />
                </div>

                {errors.ReceivedQty && (
                  <div className="alert small alert-danger">
                    {errors["ReceivedQty"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Storage Location
                </div>
                <div className="w-75">
                  <AntdSelect
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    placeholder="Select Storage Location."
                    onChange={(value) => {
                      const template = templateList.find(
                        (x) => x.Name == value
                      );
                      setSelectedTemplate(template || {});
                      handleOnChange({
                        currentTarget: { name: "Location", value: value },
                      });
                    }}
                    value={Inputdata.Location || []}
                    style={{ width: "100%" }}
                  >
                    {RMStorageList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                  {/* <input
                    required
                    // onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Storage Location"
                   disabled={opStatus === "view" ? true:opStatus === "update" ? true :false}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="Location"
                    value={Inputdata.Location}
                  /> */}
                </div>

                {errors.Location && (
                  <div className="alert small alert-danger">
                    {errors["Location"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Test Report Number
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Test Report Number"
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="TestReportNo"
                    value={Inputdata.TestReportNo}
                  />
                </div>

                {errors.TestReportNo && (
                  <div className="alert small alert-danger">
                    {errors["TestReportNo"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  No. Of Packages
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="No Of Packages"
                    disabled={
                      opStatus === "view"
                        ? true
                        : opStatus === "update"
                        ? false
                        : false
                    }
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    name="NumOfPackings"
                    value={Inputdata.NumOfPackings}
                  />
                </div>

                {errors.NumOfPackings && (
                  <div className="alert small alert-danger">
                    {errors["NumOfPackings"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              {opStatus == "create" ? (
                ""
              ) : ( <div className="">

               {Inputdata.RM_Type && (Inputdata.RM_Type =='Chemical' || Inputdata.RM_Type =='Carbon' || Inputdata.RM_Type =='Polymer') &&  <Collapse defaultActiveKey={["1", "2"]} onChange={callback}>
                  <Panel header="Consumed Qty" key="1">
                    <Col sm={12}>
                      {/* <div   htmlFor="operationRejectionCost mb-2"></div  > */}

                      <div className="">
                        <table className="table table-striped small table-bordered table-sm table-hover common my-1">
                          <thead className="small">
                            <tr className="table-primary text-center common-anchor">
                              <td>Date</td>
                              <td>
                                Quantity{" "}
                                {UnitOfMeasurment.length > 0 &&
                                  "(" + UnitOfMeasurment + ")"}
                              </td>
                              {/* <td>Refrence Object</td> */}
                            </tr>
                          </thead>
                          <tbody>
                            {Inputdata.ConsumedQty &&
                              Inputdata.ConsumedQty.length > 0 &&
                              Inputdata.ConsumedQty.map((itm) => (
                                <tr className=" text-center">
                                  <td>
                                    {itm.Date && moment(itm.Date).format("DD-MM-YYYY")}
                                  </td>
                                  <td>{itm.Qty}</td>
                                  {/* <td>{item.ReferenceObj}</td> */}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* {errors.ExpiryDate && (
                  <div className="alert small alert-danger">
                  {errors["ExpiryDate"]}
                  </div>
                  )} */}
                    </Col>
                  </Panel>
                  <Panel header="Adjusted Qty" key="2">
                    <Col sm={12}>
                      {/* <div   htmlFor="operationRejectionCost mb-2">Adjusted Qty</div  > */}
                      <div className="">
                        {opStatus === "view" ? (
                          ""
                        ) : (
                          <div className="d-flex  justify-content-between gap-2">
                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">Date </div>
                                <input
                                  required
                                  onChange={(e) => {
                                    setDate(e.currentTarget.value);
                                  }}
                                  disabled={opStatus === "view" ? true : false}
                                  placeholder="Invoice Date"
                                  className="form-control form-control-sm"
                                  type="date"
                                  name="Date"
                                  value={
                                    Date
                                    //   &&
                                    //   Date
                                    //   .split("T")[0]) ||
                                    // ""
                                  }
                                  />
                              </div>
                            </div>
                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">
                                  Quantity{" "}
                                  {UnitOfMeasurment.length > 0 &&
                                    "(" + UnitOfMeasurment + ")"}
                                </div>

                                <input
                                  required
                                  onChange={(e) => {
                                    setQuantity(e.currentTarget.value);
                                  }}
                                  style={{ height: "30px" }}
                                  placeholder="Test Quantity"
                                  disabled={opStatus === "view" ? true : false}
                                  className="form-control form-control-sm m-0"
                                  type="number"
                                  // min="0"
                                  name="Qty"
                                  value={Quantity}
                                />
                              </div>
                            </div>
                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">Type </div>
                                <AntdSelect
                                  disabled={opStatus === "view" ? true : false}
                                  placeholder="Select Type"
                                  onChange={(value) => {
                                    setType(value);
                                  }}
                                  value={Type || ""}
                                  style={{ width: "100%" }}
                                  >
                                  {["Add", "Reduce"].map((one) => {
                                    return (
                                      <AntdSelect.Option value={one}>
                                        {one}
                                      </AntdSelect.Option>
                                    );
                                  })}
                                </AntdSelect>
                              </div>
                            </div>

                            <div className="w-25">
                              <div className=" form-group text-center">
                                <div className="text-center ">Remarks </div>

                                <input
                                  type="text"
                                  placeholder="Remarks"
                                  name="Remarks"
                                  disabled={opStatus === "view" ? true : false}
                                  className="form-control form-control-sm m-0"
                                  style={{ height: "30px" }}
                                  value={Remarks || ""}
                                  // Use remarksInput state if available, else use the Remarks from the checkpoint
                                  onChange={(e) => {
                                    setRemarks(e.currentTarget.value);
                                    if (Type && BatchCode) {
                                      let qty = spareList
                                        .filter(
                                          (item) => item.SparePartId === Type
                                        )[0]
                                        ?.Qty_Available_By_Batch.filter(
                                          (one) =>
                                            one.BatchCode === BatchCode
                                        )[0].Qty;
                                        if (qty < e.currentTarget.value) {
                                          swal(
                                            "You can not exceed the batch Qty limit"
                                          );
                                        }
                                    }
                                  }}
                                  />
                              </div>
                            </div>
                          </div>
                        )}
                        {opStatus === "view"  || AdjustedQty.length > 0? (
                          ""
                        ) : (
                          <button
                          className="btn-sm btn-success"
                          onClick={() =>
                            handelONaddSpare(
                              Date,
                              Type,
                              Number(Quantity),
                              Remarks
                            )
                          }
                          >
                            + add
                          </button>
                        )}
                        {Inputdata.RM_Type && (Inputdata.RM_Type =='Chemical' || Inputdata.RM_Type =='Carbon'|| Inputdata.RM_Type =='Polymer' ) && <div className="">
                          <table className="table table-striped small table-bordered table-sm table-hover common my-1">
                            <thead className="small">
                              <tr className="table-primary text-center common-anchor">
                                <td>Date</td>
                                <td>
                                  Quantity{" "}
                                  {UnitOfMeasurment.length > 0 &&
                                    "(" + UnitOfMeasurment + ")"}{" "}
                                </td>
                                <td>Type</td>
                                <td>Remarks</td>
                              </tr>
                            </thead>
                            <tbody>
                              {Inputdata.Adjusted_Qty &&
                                Inputdata.Adjusted_Qty.length > 0 &&
                                Inputdata.Adjusted_Qty.map((item) => (
                                  <tr className="text-center">
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                      >
                                      {moment(item.Date).format("DD-MM-YYYY")}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                    >
                                      {item.Qty}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                      >
                                      {item.Type}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                      >
                                      {item.Remarks}
                                    </td>
                                  </tr>
                                ))}
                              {AdjustedQty.length > 0 &&
                                AdjustedQty.map((item, index) => (
                                  <tr className=" text-center">
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                    >
                                      {moment(item.Date).format("DD-MM-YYYY")}{" "}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                            ? "#ffd6d2"
                                            : "#c9ffef"
                                        }`,
                                      }}
                                    >
                                      {item.Qty}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                      >
                                      {item.Type}
                                    </td>
                                    <td
                                      style={{
                                        backgroundColor: `${
                                          item.Type == "Reduce"
                                          ? "#ffd6d2"
                                          : "#c9ffef"
                                        }`,
                                      }}
                                      >
                                      {item.Remarks}
                                    </td>
                                    {opStatus === "view" ? (
                                      ""
                                    ) : (
                                      <button
                                        className="btn-sm btn-danger "
                                        onClick={() => handleClear(item, index)}
                                        >
                                        x
                                      </button>
                                    )}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>}
                      </div>
                      {/* {errors.ExpiryDate && (
                  <div className="alert small alert-danger">
                  {errors["ExpiryDate"]}
                  </div>
                  )} */}
                    </Col>
                  </Panel>
                </Collapse>}
                  </div>
              )}
            </Col>
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex bg-success">
                <div className="w-25" htmlFor="operationRejectionCost">Available Qty</div >
                <div className="w-75">
                <input
                  required
                  onChange={handleOnChange}
                  style={{ width: "100%" }}
                  placeholder="Available Qty"
                  disabled={false}
                  className="form-control form-control-sm"
                  type="text"
                  // min="0"
                  name="Available"
                  value={Inputdata.Available_Qty}
                />
                </div>
                
                {errors.Available_Qty && (
                  <div className="alert small alert-danger">
                    {errors["Available_Qty"]}
                  </div>
                )}
              </div>
            </Col> */}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          {opStatus === "view" ? (
            ""
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                // const error = validateCheckCheckPoints(rows);
                // if (error.IsError) {
                //   swal("ERROR", error.message.join(", "), { dangerMode: true });
                // } else {
                  handelSaveData(Inputdata, AdjustedQty);
                // }
              }}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Add RM Inventory</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(Inputdata.NumOfPackings, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>
                  <div
                    style={{ overflowY: "scroll", height: "72vh" }}
                    className=""
                  >
                    {QRCodeArray.map((group, index) => (
                      <div className="a4-sheet-scrollable">
                        <div
                          className="a4-page"
                          // key={pageIndex}
                          style={{ pageBreakAfter: "always" }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: `repeat(${Math.sqrt(
                                16
                              )}, 1fr)`, // 3 columns in each row
                              gridTemplateRows: `repeat(${Math.sqrt(
                                16
                              )}, auto)`, // 3 rows per page (auto height)
                              gap: "57px", // Optional: Adjust the gap between items as needed
                              justifyItems: "center",
                              alignItems: "center",
                            }}
                          >
                            {group.map((one, index) => (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center "
                                key={index}
                                style={{ textAlign: "center",marginBottom:'10px'}}
                              >
                                <QRCodeSVG
                                  value={one.QrCode}
                                  level={'M'}
                                  size={80}
                                  style={{marginBottom:'3px'}}
                                />{" "}
                                {/* Adjust the size of the QR code */}
                                <p
                                  style={{ fontSize: "9px", color: "black" ,letterSpacing: "0.5px",lineHeight:'1.2'}}
                                  className="bolder p-0 m-0"
                                >
                                  {one.UID ?? "unknown"} 

                                  <br />
                                  {one.RM_ID} / {one.InvoiceDate}
                                  <br />

                                  {one.Location}


                                </p>
                               
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
              // [...Array(Number(Inputdata.NumOfPackings))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfPackings}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      
      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button> */}
      {/* {getRightsForAccess('DynamicDataRights', RightName, "write") && <Excelimport />} */}
      {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary "
          onClick={() => downloadPDFforAll(PdfData)}
        >
           RM Inventory (pdf)
        </button>
      )}
      {
        <button
          disabled={!getRightsForAccess("DynamicDataRights", RightName, "write")}
          className="btn-sm btn-success mx-2 "
          onClick={() => {
            setQRCodeVisible(false);
            setmodelState(true);
            setInputData({});
            setUpdate({});
            setSelectedTemplate({});
            setopStatus("create");
            setUnitOfMeasurment("");
          }}
        >
          Add RM Inventory
        </button>
      }
      {RawMaterialData.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
        columns={columns}
        onSort={handleSort}
        sortColumn={sortColumn}
        data={RawMaterialData}
      />
      
      
      )}
       {RawMaterialData.length > 0 && <div className="float-end m-3">
                <PaginationComponent  defaultCurrent={CurrentPage} total={TotalPage} CurrentPageNumber={(currentpage, pagesize) => { setCurrentPage(currentpage); setPageSize(pagesize) }} />
            </div>}
    </>
  );
};

export default RMInventory;
